@import '~style-sheet-helpers/core.less';
@import '../../../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../../../constants/spacing.module.less';

.text-input {
  width: 100%;
  border: 1px solid @settings-page--automation-rules-input--border-color;
  height: 32px;
}

.text-area-input {
  width: 100%;
  border: 1px solid @settings-page--automation-rules-input--border-color;
  padding: 4px 10px;
  font-size: 14px;
}

.weight-input {
  width: 100%;
}

.hold-order-for {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  .control-wrap {
    > div {
      display: inline-block;
    }
  }
  input {
    border: 1px solid @settings-page--automation-rules-input--border-color;
    width: 50px;
    height: 32px;
  }
  &.error {
    input {
      border-color: @settings-page--automation-rules-input--error--border-color;
    }
  }
}

.set-days-around-date {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.days-input {
  width: 68px;
  height: 32px;
  border: 1px solid @settings-page--automation-rules-input--border-color;

  &.error {
    border-color: @settings-page--automation-rules-input--error--border-color;
  }
}

.date-type-dropdown {
  flex: 1;
}

.text-area-component {
  display: flex;
  flex-direction: column;
  > div {
    width: 100%;
    &:last-of-type {
      text-align: right;
    }
  }
}

.multi-control {
  flex-direction: column;
}

.multi-control-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  > div {
    padding: 4px 0;
    width: 100%;
    &:first-of-type:not(.checkbox-wrap) {
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      padding-bottom: 0;
      padding-top: 0;
    }
    &:last-of-type {
      padding: @space-4 0;
    }
    &.text-area {
      padding: @space-4 0 0 0;
    }
    &.counter {
      padding: 0;
    }
  }
}

.checkbox-wrap,
.stacked {
  padding-top: 6px;
}

.checkbox-wrap {
  .truncate();
}

.hold-order-container {
  display: flex;
  align-items: flex-end;
  gap: @space-8;

  .multi-control-row {
    width: auto;
  }
}

.hold-indefinitely-wrap {
  align-self: flex-end;
  padding-bottom: @space-4;
}

.unexpected-value {
  color: @settings-page--automation-rules-input--error--border-color;
}

.checkbox {
  font-weight: 500;
}

.create-alert {
  display: flex;
  flex-direction: column;
  > div {
    width: 100%;
  }
}

.set-package-dimensions {
  align-items: center;
  width: 360px;
}

.dangerous-goods {
  display: flex;
  flex-direction: column;
}

.edit-date-picker {
  height: 32px;
  input,
  button {
    height: 32px;
  }
  input {
    border: 1px solid @settings-page--automation-rules-input-date-picker--border-color;
  }
}

.tax-identifier-dropdown {
  margin-top: 4px;
}

.tax-id-bank {
  background-color: @settings-page--automation-rules-input--background-color;
}
